/* eslint-disable no-debugger */
import { useState } from 'react';
import useCustomerSatisfactionData from '../../../../state/customerSatisfaction/UseCustomerSatisfactionData';

const INITIAL_STATE = {
  surveyComplete: false
};

const useCustomerSatisfaction = (count, dataKeyName, dataKeyValue, customerSatisfactionId) => {
  const { postCustomerSatisfaction, putCustomerSatisfaction } = useCustomerSatisfactionData();
  const [rating, setRating] = useState(null);
  const [temporaryRating, setTemporaryRating] = useState(null);
  const [comments, setComments] = useState('');
  const [uIState, setUiState] = useState(INITIAL_STATE);

  const stars = Array.from({ length: count }, (_, index) => ({
    id: index + 1,
    isActive: (rating || temporaryRating) === index + 1,
  }));

  const handleClick = () => {
    const satisfactionObj = {
      ranking: rating || 0,
      comment: comments || '',
      [dataKeyName]: dataKeyValue
    };

    if (customerSatisfactionId > 0) {
      const putCustomerSatisfactionPromise = putCustomerSatisfaction(customerSatisfactionId, satisfactionObj);

      if (putCustomerSatisfactionPromise ?? false) {
        putCustomerSatisfactionPromise.then((newState) => {
          if (newState ?? false) {
            //set ui state to show success message
            setUiState({
              ...uIState,
              surveyComplete: true
            });
          }
        }).catch((e) => {
          //state error
        });
      }
    } else {
      const postCustomerSatisfactionPromise = postCustomerSatisfaction(satisfactionObj);
      
      if (postCustomerSatisfactionPromise ?? false) {
        postCustomerSatisfactionPromise.then((newState) => {
          if (newState ?? false) {
            //set ui state to show success message
            setUiState({
              ...uIState,
              surveyComplete: true
            });
          }
        }).catch((e) => {
          //state error
        });
      }
    }
  };

  return {
    uIState,
    rating,
    setRating,
    temporaryRating,
    setTemporaryRating,
    comments,
    setComments,
    stars,
    handleClick
  };
}

export default useCustomerSatisfaction;